import { BreadcrumbProps } from "/Models/Generated/BreadcrumbProps";
import { createSpreadableBem } from "/Helpers/createBem";
import "./BreadcrumbsPopOver.scss";

interface BreadcrumbsPopOverProps {
  truncatedBreadcrumbs: BreadcrumbProps[];
  theme?: "default" | "insight";
  ref?: React.Ref<HTMLDivElement>;
}

const BreadcrumbsPopOver = ({
  truncatedBreadcrumbs,
  theme = "default",
  ref,
}: BreadcrumbsPopOverProps) => {
  const bem = createSpreadableBem("breadcrumbs-pop-over-norad");

  return (
    <div
      {...bem("", {
        "--insight": theme === "insight",
      })}
      role="menu"
      aria-label="Hidden breadcrumb items"
      ref={ref}
    >
      <div
        {...bem("__arrow", {
          "--insight": theme === "insight",
        })}
      />
      <div {...bem("__content")}>
        {truncatedBreadcrumbs.map(
          (breadcrumb, index) =>
            breadcrumb.link && (
              <a
                key={breadcrumb.link.href + index.toString()}
                {...bem("__link", {
                  "--insight": theme === "insight",
                })}
                href={breadcrumb.link.href}
                {...(breadcrumb.link.target
                  ? { target: breadcrumb.link.target }
                  : {})}
                {...(breadcrumb.link.isExternal
                  ? { rel: "noopener noreferrer" }
                  : {})}
              >
                <span>{breadcrumb.link.text}</span>
              </a>
            )
        )}
      </div>
    </div>
  );
};

export default BreadcrumbsPopOver;
